import React from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";

export const SettingsLayout: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isGeneralSettings = location.pathname === '/app/settings';
  const isWorkflowSettings = location.pathname === '/app/settings/workflow';
  const isAgentSettings = location.pathname.startsWith('/app/settings/agents');
  const isMCPSettings = location.pathname === '/app/settings/mcp';

  return (
    <div className="flex-1 overflow-hidden">
      <div className="h-full flex flex-col">
        {/* Header */}
        <div className="flex-shrink-0 p-6 border-b border-border-primary">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-bold text-white">Settings</h1>
              <p className="text-gray-400 mt-1">Configure your AI agent workflows and preferences</p>
            </div>
            <button
              onClick={() => navigate('/app')}
              className="px-4 py-2 bg-gray-700 hover:bg-gray-600 text-white rounded-lg transition-colors flex items-center gap-2"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
              Close
            </button>
          </div>
        </div>

        {/* Settings Navigation */}
        <div className="flex-shrink-0 border-b border-border-primary">
          <nav className="flex px-6">
            <button
              onClick={() => navigate('/app/settings')}
              className={`px-4 py-3 text-sm font-medium border-b-2 transition-colors ${
                isGeneralSettings
                  ? 'border-primary-500 text-primary-400'
                  : 'border-transparent text-gray-400 hover:text-gray-300'
              }`}
            >
              General
            </button>
            <button
              onClick={() => navigate('/app/settings/workflow')}
              className={`px-4 py-3 text-sm font-medium border-b-2 transition-colors ${
                isWorkflowSettings
                  ? 'border-primary-500 text-primary-400'
                  : 'border-transparent text-gray-400 hover:text-gray-300'
              }`}
            >
              Workflow Agents
            </button>
            <button
              onClick={() => navigate('/app/settings/agents')}
              className={`px-4 py-3 text-sm font-medium border-b-2 transition-colors ${
                isAgentSettings
                  ? 'border-primary-500 text-primary-400'
                  : 'border-transparent text-gray-400 hover:text-gray-300'
              }`}
            >
              Agent Settings
            </button>
            <button
              onClick={() => navigate('/app/settings/mcp')}
              className={`px-4 py-3 text-sm font-medium border-b-2 transition-colors ${
                isMCPSettings
                  ? 'border-primary-500 text-primary-400'
                  : 'border-transparent text-gray-400 hover:text-gray-300'
              }`}
            >
              MCP Servers
            </button>
          </nav>
        </div>

        {/* Settings Content */}
        <div className="flex-1 overflow-hidden">
          <Outlet />
        </div>
      </div>
    </div>
  );
};
